module.exports = __webpack_public_path__ + "static/media/ke.6e6a47cb.svg";